import { render, staticRenderFns } from "./LocaleSheet.vue?vue&type=template&id=6f022ec8&scoped=true"
import script from "./LocaleSheet.vue?vue&type=script&lang=js"
export * from "./LocaleSheet.vue?vue&type=script&lang=js"
import style0 from "./LocaleSheet.vue?vue&type=style&index=0&id=6f022ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f022ec8",
  null
  
)

export default component.exports